/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

/**
 * Kasutamine:
 * let formatter = new BaseFormatter(schema, params);
 * let formattedValue = formatter.format(value);
 */
class BaseFormatter {
    /**
     *
     * @param {Schema} schema
     * @param {Array} params
     */
    constructor(schema, params) {
        this.schema = schema;
        this.params = params;
    }

    format(value) {
        if (value == null) return "";
        return value.toString();
    }
}

export default BaseFormatter;
